<nav class="nav" *ngIf="userLogIn">
  <a class="logo-link" [routerLink]="['/dashboard']" title="Dashboard">
    <img class="logo-img" src="assets/gatherco-logo-white.svg" alt="GatherCo"/>
  </a>

  <span class="spacer"></span>

  <!-- Mobile navigation (burger) — shown under 1080px -->
  <button type="button" class="burger" aria-label="Menu" (click)="mobileOpen = !mobileOpen">
    <svg *ngIf="mobileOpen" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2.2" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
    <svg *ngIf="!mobileOpen" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2.2" stroke-linecap="round"><path d="M3 6h18M3 12h18M3 18h18"/></svg>
  </button>

  <div class="menu">
    <a [routerLink]="['/dashboard']" routerLinkActive="active">Dashboard</a>

    <div class="more" [class.is-open]="openMenu === 'customers'" (mouseleave)="closeMenu('customers')">
      <a role="button" tabindex="0" [attr.aria-expanded]="openMenu === 'customers'"
         (click)="toggleMenu('customers', $event)" (keydown.enter)="toggleMenu('customers', $event)"
         [class.active]="isCustomersActive">Customers<span class="tb" *ngIf="pendingContactCount">{{pendingContactCount}}</span><span class="caret">▼</span></a>
      <div class="dropdown">
        <a [routerLink]="['/accounts']" routerLinkActive="active">Accounts</a>
        <a [routerLink]="['/contacts']" routerLinkActive="active">Contacts
          <span class="dd-badge" *ngIf="pendingContactCount">{{pendingContactCount}}</span></a>
      </div>
    </div>

    <div class="more" [class.is-open]="openMenu === 'sales'" (mouseleave)="closeMenu('sales')">
      <a role="button" tabindex="0" [attr.aria-expanded]="openMenu === 'sales'"
         (click)="toggleMenu('sales', $event)" (keydown.enter)="toggleMenu('sales', $event)"
         [class.active]="isSalesActive">Sales<span class="tb" *ngIf="sampleCount">{{sampleCount}}</span><span class="caret">▼</span></a>
      <div class="dropdown">
        <a [routerLink]="['/sample-requests']" routerLinkActive="active">Sample Requests
          <span class="dd-badge" *ngIf="sampleCount">{{sampleCount}}</span></a>
        <a [routerLink]="['/quotes']" routerLinkActive="active">Quotes</a>
        <a [routerLink]="['/orders']" [class.active]="isOrdersActive">Orders</a>
      </div>
    </div>

    <div class="more" [class.is-open]="openMenu === 'fulfilment'" (mouseleave)="closeMenu('fulfilment')">
      <a role="button" tabindex="0" [attr.aria-expanded]="openMenu === 'fulfilment'"
         (click)="toggleMenu('fulfilment', $event)" (keydown.enter)="toggleMenu('fulfilment', $event)"
         [class.active]="isFulfilmentActive">Fulfilment<span class="tb" *ngIf="totalStockAllocationProductCount">{{totalStockAllocationProductCount}}</span><span class="caret">▼</span></a>
      <div class="dropdown">
        <a [routerLink]="['/samples-fulfilment']" routerLinkActive="active">Samples Fulfilment</a>
        <a [routerLink]="['/despatch']" [class.active]="isDespatchActive">Despatch</a>
        <a [routerLink]="['/stock-allocation']" routerLinkActive="active">Stock Allocation
          <span class="dd-badge" *ngIf="totalStockAllocationProductCount">{{totalStockAllocationProductCount}}</span></a>
      </div>
    </div>

    <a [routerLink]="['/products']" routerLinkActive="active">Products</a>
    <a [routerLink]="['/tasks']" routerLinkActive="active">Tasks
      <span class="tb" *ngIf="pendingTaskCount">{{pendingTaskCount}}</span></a>
    <a [routerLink]="['/email']" routerLinkActive="active">E-mail</a>

    <div class="more" [class.is-open]="openMenu === 'content'" (mouseleave)="closeMenu('content')">
      <a role="button" tabindex="0" [attr.aria-expanded]="openMenu === 'content'"
         (click)="toggleMenu('content', $event)" (keydown.enter)="toggleMenu('content', $event)"
         [class.active]="isContentActive">Content<span class="caret">▼</span></a>
      <div class="dropdown">
        <a [routerLink]="['/blogs']" routerLinkActive="active">Blogs</a>
        <a [routerLink]="['/projects']" routerLinkActive="active">Projects</a>
        <a [routerLink]="['/resource']" routerLinkActive="active">Resources</a>
        <a [routerLink]="['/faq']" routerLinkActive="active">FAQs</a>
        <!-- Temporarily hidden (code kept intact) — remove the inline style to restore. -->
        <a [routerLink]="['/pebbl-feedback']" routerLinkActive="active" style="display: none">Pebbl Feedback</a>
        <a [routerLink]="['/pebbl-knowledge-feedback']" routerLinkActive="active" style="display: none">Pebbl Knowledge Base</a>
      </div>
    </div>
  </div>

  <div class="right" (click)="mobileOpen = false">
    <a class="icon-circle pebbl-icon tip tip-down" [routerLink]="['/ai']" aria-label="Ask Pebbl AI"
       data-tip="Ask Pebbl - your AI assistant for products, orders and customers.">
      <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
        <path d="M17.1982 1.9002V5.50011M18.9982 3.70016H15.3982M2.79858 14.4999V16.2998M3.69856 15.3999H1.8986M8.14174 13.1499C8.06139 12.8385 7.89905 12.5542 7.67161 12.3268C7.44417 12.0993 7.15993 11.937 6.84847 11.8567L1.32712 10.4329C1.23292 10.4062 1.15001 10.3494 1.09098 10.2713C1.03194 10.1932 1 10.0979 1 10C1 9.90208 1.03194 9.80683 1.09098 9.72871C1.15001 9.65058 1.23292 9.59385 1.32712 9.56711L6.84847 8.14245C7.15982 8.06217 7.44398 7.89997 7.67141 7.67269C7.89885 7.44542 8.06125 7.16137 8.14174 6.85008L9.5655 1.32872C9.59197 1.23414 9.64865 1.15083 9.72689 1.09148C9.80513 1.03213 9.90064 1 9.99884 1C10.097 1 10.1926 1.03213 10.2708 1.09148C10.349 1.15083 10.4057 1.23414 10.4322 1.32872L11.855 6.85008C11.9354 7.16153 12.0977 7.44577 12.3252 7.67321C12.5526 7.90066 12.8369 8.063 13.1483 8.14335L18.6697 9.56621C18.7646 9.5924 18.8483 9.64902 18.908 9.72737C18.9677 9.80573 19 9.90151 19 10C19 10.0985 18.9677 10.1943 18.908 10.2726C18.8483 10.351 18.7646 10.4076 18.6697 10.4338L13.1483 11.8567C12.8369 11.937 12.5526 12.0993 12.3252 12.3268C12.0977 12.5542 11.9354 12.8385 11.855 13.1499L10.4313 18.6713C10.4048 18.7659 10.3481 18.8492 10.2699 18.9085C10.1917 18.9679 10.0961 19 9.99794 19C9.89974 19 9.80423 18.9679 9.72599 18.9085C9.64775 18.8492 9.59107 18.7659 9.5646 18.6713L8.14174 13.1499Z" stroke="#D3AF56" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </a>

    <button class="icon-circle tip tip-down" (click)="openSearchDialog()"
            data-tip="Search accounts, contacts, samples, quotes and orders. (⌘K)" aria-label="Search">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
           stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8"/>
        <path d="M21 21l-4.35-4.35"/>
      </svg>
    </button>

    <button class="icon-circle tip tip-down" data-tip="Notifications" aria-label="Notifications"
            (click)="openNotificationSidebar($event)">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
           stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
      </svg>
      <span class="badge" *ngIf="unReadNotificationCount > 0">{{unReadNotificationCount}}</span>
    </button>

    <div class="more" [class.is-open]="openMenu === 'settings'">
      <button class="icon-circle" title="Admin settings" (click)="toggleMenu('settings', $event)">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="3"/>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h.09a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
        </svg>
      </button>
      <div class="dropdown">
        <a [routerLink]="['/users']" routerLinkActive="active">Users</a>
        <a [routerLink]="['/settings']" routerLinkActive="active">Settings</a>
        <a [routerLink]="['/email-templates']" routerLinkActive="active">Email Templates</a>
        <a [routerLink]="['/carrier']" routerLinkActive="active">Carrier Management</a>
        <a [routerLink]="['/supplier-management']" routerLinkActive="active">Supplier Management</a>
        <a [routerLink]="['/consumables-calculator']" routerLinkActive="active">Consumables Calculator</a>
        <a [routerLink]="['/task-categories']" routerLinkActive="active">Task Categories</a>
      </div>
    </div>

    <button class="theme-btn tip tip-down" (click)="toggleTheme()" aria-label="Light / dark mode"
            data-tip="Switch between light and dark mode.">
      <svg *ngIf="!isLight" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
           stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="5"/>
        <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>
      </svg>
      <svg *ngIf="isLight" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
           stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
      </svg>
    </button>

    <!-- Profile — hover dropdown (matches console-v2 .profile .dropdown).
         On touch it opens via an explicit tap (`.is-open`) — see toggleMenu. -->
    <div class="more profile" [class.is-open]="openMenu === 'profile'">
      <button type="button" class="profile-btn" aria-haspopup="menu"
              [attr.aria-expanded]="openMenu === 'profile'" (click)="toggleMenu('profile', $event)">
        <!-- `.avatar-img` (not `.avatar`) so the component's sizing + 640px
             responsive resize actually match — see header.component.css.
             With no photo (or one that 404s) the initials stand in, matching the
             account/contact identity headers instead of a generic silhouette. -->
        <img *ngIf="profileAvatar && !avatarFailed" class="avatar-img" [src]="profileAvatar"
             (error)="avatarFailed = true" alt="Profile Picture" />
        <span *ngIf="!profileAvatar || avatarFailed" class="avatar-img avatar-initials"
              [class.is-loading]="!identityLoaded"
              [attr.aria-label]="username">{{ profileInitials }}</span>
        <!-- The name is only known once /me answers (the profile is held in
             memory, so a reload always starts blank). Until then a skeleton fills
             the SAME reserved slot, so the header does not resize underneath the
             cursor when the name lands — see `.user` in the component CSS. -->
        <span class="user" [attr.aria-busy]="!identityLoaded ? 'true' : null">
          <span *ngIf="!identityLoaded" class="user-skeleton" aria-hidden="true"
                style="width: 100%"></span>
          <ng-container *ngIf="identityLoaded">{{ identity?.first_name | titlecase }} {{ identity?.last_name | titlecase }}</ng-container>
        </span>
        <span class="caret">▼</span>
      </button>
      <div class="dropdown" role="menu">
        <a role="menuitem" (click)="openEditProfile()">Edit Profile</a>
        <a role="menuitem" (click)="openChangePassword()">Change Password</a>
        <div class="divider"></div>
        <a role="menuitem" class="logout" (click)="confirmLogout()">Log Out</a>
      </div>
    </div>
  </div>

  <!-- Mobile navigation menu (burger) — shown under 1080px -->
  <ng-container *ngIf="mobileOpen">
    <div class="m-scrim" (click)="mobileOpen = false"></div>
    <div class="m-menu">
      <a [routerLink]="['/dashboard']" routerLinkActive="active" (click)="mobileOpen = false">Dashboard</a>

      <span class="m-group">Customers</span>
      <a [routerLink]="['/accounts']" routerLinkActive="active" (click)="mobileOpen = false">Accounts</a>
      <a [routerLink]="['/contacts']" routerLinkActive="active" (click)="mobileOpen = false">Contacts
        <span class="dd-badge" *ngIf="pendingContactCount">{{pendingContactCount}}</span></a>

      <span class="m-group">Sales</span>
      <a [routerLink]="['/sample-requests']" routerLinkActive="active" (click)="mobileOpen = false">Sample Requests
        <span class="dd-badge" *ngIf="sampleCount">{{sampleCount}}</span></a>
      <a [routerLink]="['/quotes']" routerLinkActive="active" (click)="mobileOpen = false">Quotes</a>
      <a [routerLink]="['/orders']" [class.active]="isOrdersActive" (click)="mobileOpen = false">Orders</a>

      <span class="m-group">Fulfilment</span>
      <a [routerLink]="['/samples-fulfilment']" routerLinkActive="active" (click)="mobileOpen = false">Samples Fulfilment</a>
      <a [routerLink]="['/despatch']" [class.active]="isDespatchActive" (click)="mobileOpen = false">Despatch</a>
      <a [routerLink]="['/stock-allocation']" routerLinkActive="active" (click)="mobileOpen = false">Stock Allocation
        <span class="dd-badge" *ngIf="totalStockAllocationProductCount">{{totalStockAllocationProductCount}}</span></a>

      <span class="m-group">More</span>
      <a [routerLink]="['/products']" routerLinkActive="active" (click)="mobileOpen = false">Products</a>
      <a [routerLink]="['/tasks']" routerLinkActive="active" (click)="mobileOpen = false">Tasks
        <span class="dd-badge" *ngIf="pendingTaskCount">{{pendingTaskCount}}</span></a>
      <a [routerLink]="['/email']" routerLinkActive="active" (click)="mobileOpen = false">E-mail</a>

      <span class="m-group">Content</span>
      <a [routerLink]="['/blogs']" routerLinkActive="active" (click)="mobileOpen = false">Blogs</a>
      <a [routerLink]="['/projects']" routerLinkActive="active" (click)="mobileOpen = false">Projects</a>
      <a [routerLink]="['/resource']" routerLinkActive="active" (click)="mobileOpen = false">Resources</a>
      <a [routerLink]="['/faq']" routerLinkActive="active" (click)="mobileOpen = false">FAQs</a>
      <!-- Temporarily hidden (code kept intact) — remove the inline style to restore. -->
      <a [routerLink]="['/pebbl-feedback']" routerLinkActive="active" (click)="mobileOpen = false" style="display: none">Pebbl Feedback</a>
      <a [routerLink]="['/pebbl-knowledge-feedback']" routerLinkActive="active" (click)="mobileOpen = false" style="display: none">Pebbl Knowledge Base</a>

      <span class="m-group">Appearance</span>
      <a (click)="toggleTheme()">
        <svg *ngIf="isLight" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>
        <svg *ngIf="!isLight" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>
        {{ isLight ? 'Dark mode' : 'Light mode' }}
      </a>
    </div>
  </ng-container>
</nav>

<!-- Profile forms (edit profile / change password) — opened from the profile menu -->
<app-edit-profile #editProfileModal [identity]="identity" [avatarUrl]="profileAvatarLarge"
                  [fallbackImage]="noImage" (photoRemoved)="onProfilePhotoRemoved()"></app-edit-profile>
<app-change-password #changePasswordModal></app-change-password>

<app-notification-sidebar *ngIf="isOpenNotificationSidebar" (closed)="onNotificationSidebarClosed()"></app-notification-sidebar>
